import { HsArticleData } from '@hsetu/ngui-views';
import { ArticleDataMapper } from '../mappers/article-data.mapper';
import { ItemStockItem } from './item-stock-item.model';
import { FilterBy } from '@shared/sync/filter-by.model';
import { HsDataSource } from '@hsetu/ngui-components';
import { ItemStockService } from '../services/item-stock.service';
import { inject } from '@angular/core';

export class KfmArticleCatalogDatasource {
  private readonly _itemStockService = inject(ItemStockService);

  private readonly _mapper: ArticleDataMapper = new ArticleDataMapper();

  private _loaderFn = async ({
    pageIndex,
    pageSize,
    filter,
    searchTerm,
  }: {
    pageIndex: number;
    pageSize: number;
    filter?: string;
    searchTerm?: string;
  }): Promise<{ data: HsArticleData[]; count: number }> => {
    const hasSearchTerm = !!searchTerm?.trim();
    const hasFilter = !!filter?.trim() && filter !== 'Alle';

    let filterModel: FilterBy = null;

    if (hasSearchTerm && hasFilter) {
      const filterTerm =
        'return !!i.manufacturerLabel && i.manufacturerLabel.toUpperCase() == p[0].toUpperCase() || ' +
        '!!i.infoDesc && i.infoDesc.toUpperCase().includes(p[1].toUpperCase()) || ' +
        '!!i.articleNumber && i.articleNumber.toUpperCase().includes(p[2].toUpperCase());';
      const parameters = [filter, searchTerm, searchTerm];

      filterModel = {
        filterStatement: filterTerm,
        parameters: parameters,
      };
    } else if (hasFilter) {
      const filterTerm =
        'return !!i.manufacturerLabel && i.manufacturerLabel.toUpperCase() == p[0].toUpperCase()';
      const parameters = [filter];

      filterModel = {
        filterStatement: filterTerm,
        parameters: parameters,
      };
    } else if (hasSearchTerm) {
      const filterTerm =
        'return !!i.manufacturerLabel && i.manufacturerLabel.toUpperCase().includes(p[0].toUpperCase()) || ' +
        '!!i.infoDesc && i.infoDesc.toUpperCase().includes(p[1].toUpperCase()) || ' +
        '!!i.articleNumber && i.articleNumber.toUpperCase().includes(p[2].toUpperCase());';
      const parameters = [searchTerm, searchTerm, searchTerm];

      filterModel = {
        filterStatement: filterTerm,
        parameters: parameters,
      };
    }

    const result = await this._itemStockService.getAll(
      pageSize,
      pageIndex,
      null,
      filterModel,
    );

    const items = result.data.map((itemStockItem: ItemStockItem) => {
      return this._mapper.mapToHsArticleData(itemStockItem);
    });

    return {
      data: items,
      count: result.count,
    };
  };

  public readonly dataSource = new HsDataSource<HsArticleData>(
    this._loaderFn.bind(this),
  );
}
